import { MenuM } from "@common/components/menu/MenuM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import React, { useContext } from "react"
import { View } from "react-native"
import { Icon } from "react-native-paper"
import { renderers } from "react-native-popup-menu"
import SelectableRowWithInput from "../../../common/components/interview/SelectableRowWithInput"

const LanguageSelector = (props) => {
    const {
        selectedLanguages = [],
        onLanguagesChange,
        availableLanguages = [],
        languageErrors = {},
    } = props

    const dimensions = useContext(DimensionsContext)

    const proficiencyLevels = [
        { value: 1, label: "Conversationnel" },
        { value: 2, label: "Courant" },
        { value: 3, label: "Langue maternelle" },
    ]

    const handleLanguageSelect = (languageId) => {
        const language = availableLanguages.find(
            (lang) => lang.value === languageId
        )

        if (!language) {
            return
        }

        const isSelected = selectedLanguages.some(
            (lang) => lang.value === languageId
        )

        if (!isSelected) {
            const newLanguage = {
                ...language,
            }
            const updatedLanguages = [...selectedLanguages, newLanguage]
            onLanguagesChange(updatedLanguages)
        }
    }

    const handleRemoveLanguage = (languageId) => {
        const updatedLanguages = selectedLanguages.filter(
            (lang) => lang.value !== languageId
        )
        onLanguagesChange(updatedLanguages)
    }

    const handleProficiencyChange = (languageId, proficiency) => {
        const updatedLanguages = selectedLanguages.map((lang) =>
            lang.value === languageId ? { ...lang, proficiency } : lang
        )
        onLanguagesChange(updatedLanguages)
    }

    const availableOptions = availableLanguages.filter(
        (lang) =>
            !selectedLanguages.some((selected) => selected.value === lang.value)
    )

    const menuItems = [
        {
            title: "Sélectionner une langue",
            type: "title",
        },
        ...availableOptions.map((lang) => ({
            title: lang.label,
            onPress: () => handleLanguageSelect(lang.value),
        })),
    ]

    return (
        <View style={{ width: dimensions?.width - 40 }}>
            {selectedLanguages.length > 0 && (
                <View style={{ marginBottom: 15 }}>
                    {selectedLanguages.map((language) => (
                        <SelectableRowWithInput
                            key={language.value}
                            item={language.value}
                            title={language.label}
                            icon={language.icon}
                            onRemove={handleRemoveLanguage}
                            selectOptions={proficiencyLevels}
                            selectedValue={language.proficiency}
                            onSelectChange={(proficiency) =>
                                handleProficiencyChange(
                                    language.value,
                                    proficiency
                                )
                            }
                            errors={languageErrors}
                            name={`language_${language.value}_proficiency`}
                            selectLabel="Niveau de maîtrise"
                            selectPlaceholder="Choisir un niveau"
                        />
                    ))}
                </View>
            )}

            {availableOptions.length > 0 && (
                <View style={{ alignItems: "center", marginTop: 10 }}>
                    <MenuM
                        name="add-language"
                        center
                        buttonComponent={
                            <View
                                style={{
                                    backgroundColor: theme.colors.primary,
                                    borderRadius: 20,
                                    width: 40,
                                    height: 40,
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    source={"plus"}
                                    size={20}
                                    style={{
                                        height: 30,
                                        width: 30,
                                        backgroundColor: theme.colors.primary,
                                        alignSelf: "center",
                                        borderRadius: 20,
                                    }}
                                    color={theme.colors.white}
                                    disabled
                                />
                            </View>
                        }
                        items={menuItems}
                        renderer={renderers.SlideInMenu}
                        style={{
                            borderRadius: theme.roundness,
                        }}
                    />
                </View>
            )}
        </View>
    )
}

export default LanguageSelector
